module.exports = __webpack_public_path__ + "img/icon-topic-walk.2bc1930d.svg";